import { deleteChannel } from "../../../../../actions/Utilities/Channel";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteChannel = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteChannel(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetChannels"]);
      toast.fire(
        "Success",
        "Channels has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Channels",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteChannel;
